var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldicons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23488_7976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.676 3.35832L10.9156 0.48749C10.8885 0.352074 10.7802 0.24374 10.6719 0.16249C10.5365 0.0812404 10.374 0.0812404 10.2385 0.135407H2.57396C2.38438 0.135407 2.22188 0.216657 2.11354 0.379157L0.298958 3.35832C0.190625 3.46666 0.109375 3.60207 0.109375 3.76457C0.109375 3.92707 0.190625 4.06249 0.271875 4.17082L5.98646 12.5667C6.01354 12.6208 6.04063 12.6479 6.06771 12.675C6.14896 12.7562 6.25729 12.8375 6.36563 12.8375H6.44688H6.47396H6.50104H6.60938C6.79896 12.7833 6.93438 12.6208 6.98854 12.4312L12.7302 4.14374C12.8115 4.03541 12.8656 3.92707 12.8656 3.79166C12.8656 3.60207 12.8115 3.46666 12.676 3.35832ZM9.48021 1.21874L8.36979 3.24999H4.68646L3.54896 1.21874H9.48021ZM2.60104 1.67916L3.49479 3.24999H1.62604L2.60104 1.67916ZM1.65313 4.33332H3.98229L5.33646 9.74999L1.65313 4.33332ZM6.50104 10.1292L5.06563 4.33332H7.99063L6.50104 10.1292ZM7.74688 9.56041L9.10104 4.33332H11.2948L7.74688 9.56041ZM9.61563 3.24999L10.4281 1.76041L11.349 3.24999H9.61563Z",
    fill: "#D4AF37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23488_7976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldicons);
export default __webpack_public_path__ + "static/media/goldicons.95dcbdaad346bd5be5028d6f4643d8ec.svg";
export { ForwardRef as ReactComponent };